<template>
  <div
    :class="{
      'mx-auto mb-4 w-full max-w-36 px-2 md:mb-0': true,
    }"
    :style="gridStyle"
  >
    <PtcPicture
      v-if="image.asset"
      provider="sanity"
      :src="image.asset._ref"
      :alt="image.altText"
      fit="outside"
      :class="{
        'w-full align-middle lg:max-h-full lg:max-w-full': true,
      }"
      :img-attrs="{
        class: { 'max-h-70px w-full mx-auto': true },
      }"
      :modifiers="{
        crop: image.crop,
        hotspot: image.hotspot,
        w: 200,
        h: 140,
      }"
    />
  </div>
</template>

<script lang="ts" setup>
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { Logo } from '~/sanity/types';
interface Props extends Logo {
  index: number;
  totalItems: number;
  itemsInLastRow: number;
  lastRowStartColumn: number;
}
const props = defineProps<Props>();
const { index, totalItems } = props;
const { lastRowStartColumn, itemsInLastRow } = toRefs(props);

const gridStyle = useFlushCompute(() => {
  if (index === totalItems - itemsInLastRow.value) {
    return {
      gridColumnStart: String(lastRowStartColumn.value),
    };
  }
  return { gridColumnStart: 'auto' };
});
</script>

<style></style>
